import CopyLink from '../src/CopyLink';
export default CopyLink;
